<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场景名称：</span>
        </div>
        <el-select v-model="ScenesCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   placeholder="请选择场景">
          <el-option v-for="item in scenesList" :key="item.key"
                     :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">支付条件：</span>
        </div>
        <el-select v-model="formData.paymentTerm"
                   filterable
                   remote
                   reserve-keyword
                   :remote-method="remoteMethod1"
                   size="small" style="width: 280px"
                   placeholder="请选择支付条件">
          <el-option v-for="item in paymentTermList" :key="item.value"
                     :label="item.desc" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">支付方式：</span>
        </div>
        <el-select v-model="formData.paymentMethod"
                   filterable
                   remote
                   reserve-keyword
                   :remote-method="remoteMethod2"
                   size="small" style="width: 280px"
                   placeholder="请选择支付方式">
          <el-option v-for="item in paymentMethodList" :key="item.value"
                     :label="item.desc" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">会计科目：</span>
        </div>
        <el-select v-model="accountingSubjectCode"
                   filterable
                   remote
                   reserve-keyword
                   :remote-method="remoteMethod3"
                   size="small" style="width: 280px"
                   placeholder="请选择会计科目">
          <el-option v-for="item in accountingSubjectList" :key="item.code"
                     :label="item.desc" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">费用类型：</span>
        </div>
        <el-select v-model="expenseTypeCode"
                   filterable
                   remote
                   reserve-keyword
                   :remote-method="remoteMethod4"
                   size="small" style="width: 280px"
                   placeholder="请选择费用类型">
          <el-option v-for="item in expenseTypeList" :key="item.code"
                     :label="item.desc" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">现金流项目：</span>
        </div>
        <el-select v-model="cashFlowItemCode"
                   filterable
                   remote
                   reserve-keyword
                   :remote-method="remoteMethod5"
                   size="small" style="width: 280px"
                   placeholder="请选择现金流项目">
          <el-option v-for="item in cashFlowItemList" :key="item.code"
                     :label="item.desc" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">凭证类型：</span>
        </div>
        <el-select v-model="formData.documentType"
                   filterable
                   remote
                   reserve-keyword
                   :remote-method="remoteMethod6"
                   size="small" style="width: 280px"
                   placeholder="请选择凭证类型">
          <el-option v-for="item in documentTypeList" :key="item.value"
                     :label="item.desc" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">账户类型：</span>
        </div>
        <el-select v-model="formData.accountType"
                   filterable
                   remote
                   reserve-keyword
                   :remote-method="remoteMethod7"
                   size="small" style="width: 280px"
                   placeholder="请选择凭证类型">
          <el-option v-for="item in accountTypeList" :key="item.value"
                     :label="item.desc" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">是否传递客户编号：</span>
        </div>
        <el-select v-model="formData.isCustomerCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   placeholder="请选择是否传递客户编号">
          <el-option v-for="item in isCustomerList" :key="item.key"
                     :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </div>
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Group";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "basic-information-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "数据对接",
          name: "customer-master-data"
        },
        {
          value: "场景模板"
        }
      ],
      mainTitle: "添加场景模板",
      subheading: "",
      formData: {},
      categoryList: [],
      scenesList: [
        { key: "10001", value: "开租金发票" },
        { key: "10002", value: "收租金" },
        { key: "10003", value: "开水电发票" },
        { key: "10004", value: "收水电费" },
        { key: "10005", value: "开物业费发票" },
        { key: "10006", value: "收租金及保证金" },
        { key: "10007", value: "预收租金及保证金" },
        { key: "10008", value: "冲红发票" },
        { key: "10009", value: "重新开票" },
        { key: "10010", value: "退租金及保证金" },
        { key: "10011", value: "收物业费" },
        { key: "10012", value: "开停车费发票" },
        { key: "10013", value: "收停车费" },
      ],
      ScenesCode: "",
      paymentTermList: [],
      paymentMethodList: [],
      accountingSubjectList: [],
      accountingSubjectCode: "",
      expenseTypeList: [],
      expenseTypeCode: "",
      cashFlowItemList: [],
      cashFlowItemCode: "",
      documentTypeList: [],
      accountTypeList: [],
      isCustomerList: [{ key: true, value: "是" }, { key: false, value: "否" }]
    };
  },
  created() {
    this.remoteMethod1();
    this.remoteMethod2();
    this.remoteMethod3();
    this.remoteMethod4();
    this.remoteMethod5();
    this.remoteMethod6();
    this.remoteMethod7();
  },
  methods: {
    remoteMethod1() {
      this.getPaymentTermList();
    },
    remoteMethod2() {
      this.getPaymentMethodList();
    },
    remoteMethod3() {
      this.getaccountingSubjectList();
    },
    remoteMethod4() {
      this.getExpenseTypeList();
    },
    remoteMethod5() {
      this.getCashFlowItemList();
    },
    remoteMethod6() {
      this.getDocumentTypeList();
    },
    remoteMethod7() {
      this.getAccountTypeList();
    },
    confirm() {
      console.log(this.formData);
      if (!this.formData.scenesCode) {
        nError("请选择场景");
        return false;
      }
      this.$axios
        .post(api.addScenesConfig, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "scenario-template"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "scenario-template"
      });
    },
    getPaymentTermList() {
      this.$axios
        .post(api.getDaliDictItemList, { dictType: "支付条件" })
        .then(res => {
          this.paymentTermList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    },

    getPaymentMethodList() {
      this.$axios
        .post(api.getDaliDictItemList, { dictType: "支付方式" })
        .then(res => {
          this.paymentMethodList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    },
    getaccountingSubjectList() {
      this.$axios
        .post(api.getDaliDictItemList, { dictType: "会计科目" })
        .then(res => {
          this.accountingSubjectList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    },
    getExpenseTypeList() {
      this.$axios
        .post(api.getDaliDictItemList, { dictType: "费用类型" })
        .then(res => {
          this.expenseTypeList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    },
    getCashFlowItemList() {
      this.$axios
        .post(api.getDaliDictItemList, { dictType: "现金流项目" })
        .then(res => {
          this.cashFlowItemList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    },
    getDocumentTypeList() {
      this.$axios
        .post(api.getDaliDictItemList, { dictType: "凭证类型" })
        .then(res => {
          this.documentTypeList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    },
    getAccountTypeList() {
      this.$axios
        .post(api.getDaliDictItemList, { dictType: "账户类型" })
        .then(res => {
          this.accountTypeList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    }
  },
  watch: {
    ScenesCode(val) {
      this.scenesList.map(v => {
        if (v.key == val) {
          console.log(v);
          this.formData.scenesCode = v.key;
          this.formData.scenesName = v.value;
        }
      });
    },
    accountingSubjectCode(val) {
      this.accountingSubjectList.map(v => {
        if (v.code == val) {
          this.formData.accountingSubjectNo = v.value;
          this.formData.accountingSubjectName = v.desc;
        }
      });
    },
    expenseTypeCode(val) {
      this.expenseTypeList.map(v => {
        if (v.code == val) {
          this.formData.expenseType = v.value;
          this.formData.expenseTypeName = v.desc;
        }
      });
    },
    cashFlowItemCode(val) {
      this.cashFlowItemList.map(v => {
        if (v.code == val) {
          this.formData.cashFlowItemCode = v.value;
          this.formData.cashFlowItemName = v.desc;
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/DataSync/ScenarioTemplate/ScenarioTemplateAdd.vue